/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Drawer_TitleInputs */

const en_directory_submit_drawer_title = /** @type {(inputs: Directory_Submit_Drawer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing details`)
};

const zh_directory_submit_drawer_title = /** @type {(inputs: Directory_Submit_Drawer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录详情`)
};

/**
* | output |
* | --- |
* | "Listing details" |
*
* @param {Directory_Submit_Drawer_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_drawer_title = /** @type {((inputs?: Directory_Submit_Drawer_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Drawer_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_drawer_title(inputs)
	return zh_directory_submit_drawer_title(inputs)
});
export { directory_submit_drawer_title as "directory.submit.drawer.title" }